var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 25,
    viewBox: "0 0 19 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.06016 24.2195H12.9398C16.0703 24.2195 18.6328 21.7398 18.6555 18.6773V18.632C18.6555 15.3211 16.8336 9.91484 13.9914 6.85313C13.3789 6.19531 12.7211 5.64375 12.018 5.25C11.2234 4.78906 10.3852 4.53125 9.5 4.53125C8.61484 4.53125 7.77656 4.78906 6.98203 5.25C6.27891 5.64375 5.62109 6.19531 5.00937 6.85313C2.16562 9.92266 0.34375 15.3359 0.34375 18.6852C0.367188 21.7398 2.92969 24.2195 6.06016 24.2195ZM6.59687 16.9234H8.86484V16.9688H10.1352V15.6984H6.59609V9.88516H8.36562V9.20469H10.6344V9.88438H12.4031V12.1984H10.1352V12.1531H8.86484V13.4305H12.4039V19.2375H10.6344V19.9172H8.36562V19.2375H6.59687V16.9234Z",
    fill: "#BF7609"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.49961 3.39688C10.4746 3.39688 11.3973 3.65469 12.2668 4.10781C12.9777 4.47109 13.6426 4.96953 14.2699 5.56719L15.3059 0.78125H3.69336L4.73633 5.57422C5.32772 4.99198 6.00001 4.49809 6.73242 4.10781C7.60195 3.65469 8.52461 3.39688 9.49961 3.39688Z",
    fill: "#BF7609"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBag);
export default __webpack_public_path__ + "static/media/MoneyBag.ea869d64dcc7727e7648ff7a00861e0e.svg";
export { ForwardRef as ReactComponent };